export const QUANTITY_MULTIPLIER = [
  { min: 1, max: 2, multiplier: 2 },
  { min: 3, max: 4, multiplier: 3 },
  { min: 5, max: 9, multiplier: 5 },
  { min: 10, max: 24, multiplier: 10 },
  { min: 25, max: Infinity, multiplier: 25 },
]

export const getQuantityMultiplier = (quantity: number): number => {
  const multiplier = QUANTITY_MULTIPLIER.find((m) => quantity >= m.min && quantity <= m.max)
  return multiplier?.multiplier ?? 1
}
